import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import ReactDOM from 'react-dom';

import { Modal, XMarkIcon } from '@snapask/common-components';

import LoginForm from '@dragonfruit/components/LoginForm';

import { signup as goToSignupPage } from '@dragonfruit/redux/navigation';

import styles from './LoginModal.scss';
import PurchaseModalTheme from '@dragonfruit/styles/modalTheme/checkout.scss';

function LoginModal({ onClose, t, goToSignupPage }) {
  return ReactDOM.createPortal(
    <Modal onClose={onClose} theme={PurchaseModalTheme}>
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.cross}>
            <XMarkIcon
              width={24}
              height={24}
              className={styles.closeIcon}
              onClick={onClose}
            />
          </div>
          <h2 className={styles.title}>{t('login.title')}</h2>
        </div>
        <div className={styles.body}>
          <LoginForm onSubmit={onClose} />
          <div className={styles.createAccount}>
            {t('login.do-not-have-an-account')}
            <span className={styles.signup} onClick={goToSignupPage}>
              {t('login.signup')}
            </span>
          </div>
        </div>
      </div>
    </Modal>,
    document.getElementById('modal')
  );
}
LoginModal.propTypes = {
  t: func.isRequired,
  onClose: func.isRequired,
};
LoginModal.defaultProps = {};

export default connect(null, { goToSignupPage })(
  translate(['login'])(LoginModal)
);



// WEBPACK FOOTER //
// ./app/components/LoginModal/LoginModal.jsx